import { render, staticRenderFns } from "./PageHeaderContact.vue?vue&type=template&id=39292527&"
import script from "./PageHeaderContact.vue?vue&type=script&lang=js&"
export * from "./PageHeaderContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports